import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "appUser",
  initialState: {
    user: "",
    username: "",
    userId: ""
  },
  reducers: {
    addUserInfo(state, action) {
      state.user = action.payload.user;
      state.username = action.payload.username;
      state.userId = action.payload.userId;
    }
  }
})